/* eslint-disable react/jsx-no-target-blank */
import { useAuth } from '../../../../../app/modules/auth';
import {
	SHOW_SHOP_SECTIONS,
	SHOW_STRATAPAY_SECTIONS,
	SHOW_TELEGRAM_SECTIONS,
} from '../../../../../app/config/environment';
import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';

const SidebarMenuMain = () => {
	const {
		isAdmin,
		isModerator,
		isContents,
		isArbitrator,
		isManager,
		isSupport,
	} = useAuth();

	return (
		<>
			<div className='menu-item'>
				<div className='menu-content pt-8 pb-2'>
					<span className='menu-section text-muted text-uppercase fs-8 ls-1'>
						Меню
					</span>
				</div>
			</div>
			<SidebarMenuItem
				to='/apps/user-management/users'
				icon='profile-user'
				title='Пользователи'
				fontIcon='bi-layers'
			/>
			{isModerator && (
				<SidebarMenuItem
					to='/apps/arbitrators-management/list'
					icon='security-user'
					title='Арбитры'
					fontIcon='bi-layers'
				/>
			)}
			{isArbitrator && isAdmin && isModerator ? (
				<SidebarMenuItemWithSub
					to='/apps/dispute-management/*'
					icon='message-notif'
					title='Спор'
					fontIcon='bi-layers'
				>
					<SidebarMenuItem
						to='/apps/dispute-management/dispute'
						title='Арбитраж'
						hasBullet={true}
					/>
					<SidebarMenuItem
						to='/apps/dispute-management/early-dispute'
						title='Досрочный арбитраж'
						hasBullet={true}
					/>
				</SidebarMenuItemWithSub>
			) : isArbitrator ? (
				<SidebarMenuItem
					to='/apps/dispute-management/dispute'
					icon='message-notif'
					title='Спор'
					fontIcon='bi-layers'
				/>
			) : null}

			{isModerator && (
				<SidebarMenuItem
					to='/apps/deals-management/deals'
					icon='setting'
					title='Сделки'
					fontIcon='bi-layers'
				/>
			)}
			{isModerator && (
				<SidebarMenuItem
					to='/apps/offer-management/offers'
					icon='chart'
					title='Предложения'
					fontIcon='bi-layers'
				/>
			)}
			{/* {isManager && (
				<SidebarMenuItem
					to='/apps/withdraw-management/list'
					icon='dollar'
					title='Заявки на вывод'
					fontIcon='bi-layers'
				/>
			)} */}
			{isContents && (
				<SidebarMenuItem
					to='/apps/commission-management/list'
					icon='finance-calculator'
					title='Комиссии'
					fontIcon='bi-layers'
				/>
			)}
			{isContents && (
				<SidebarMenuItem
					to='/apps/faq'
					icon='book-open'
					title='FAQ'
					fontIcon='bi-layers'
				/>
			)}

			{(isAdmin || isArbitrator) && (
				<SidebarMenuItem
					to='/apps/metrics-management/metrics'
					icon='abstract-9'
					title='Метрики'
					fontIcon='bi-layers'
				/>
			)}

			{isManager && (
				<SidebarMenuItemWithSub
					to='/apps/trc20/*'
					icon='abstract-29'
					title='TRC-20'
				>
					<SidebarMenuItem
						to='/apps/trc20/withdraw-management/list'
						icon='dollar'
						title='Заявки на вывод'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/trc20/automatic-management/automatic'
						icon='abstract-8'
						title='История автовыводов'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/trc20/wallet-management/private-key'
						icon='key'
						title='Приватный ключ'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{isManager && (
				<SidebarMenuItemWithSub
					to='/apps/bep20/*'
					icon='abstract-49'
					title='BEP-20'
				>
					<SidebarMenuItem
						to='/apps/bep20/withdraw-management/list'
						icon='dollar'
						title='Заявки на вывод'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/bep20/automatic-management/automatic'
						icon='abstract-8'
						title='История автовыводов'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/bep20/wallet-management/private-key'
						icon='key'
						title='Приватный ключ'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/bep20/wallet-management/manual-deposit'
						icon='plus'
						title='Ручное зачисление'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/bep20/wallet-management/deposits'
						icon='abstract-8'
						title='Депозиты BNB'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{/* Пункты подменю под разными ролями: выводы — для manager, как
			    было, а ручка реестра кошельков под admin_role_depend. Поэтому
			    подменю видно обеим ролям, а каждый пункт — своей. */}
			{(isManager || isAdmin) && (
				<SidebarMenuItemWithSub
					to='/apps/cryptomus/*'
					icon='abstract-10'
					title='Cryptomus'
				>
					{isManager && (
						<SidebarMenuItem
							to='/apps/cryptomus/withdraw-management/list'
							icon='dollar'
							title='Заявки на вывод'
							fontIcon='bi-layers'
						/>
					)}
					{isManager && (
						<SidebarMenuItem
							to='/apps/cryptomus/automatic-management/automatic'
							icon='abstract-8'
							title='История автовыводов'
							fontIcon='bi-layers'
						/>
					)}
					{isAdmin && (
						<SidebarMenuItem
							to='/apps/cryptomus/wallets'
							icon='wallet'
							title='Кошельки'
							fontIcon='bi-layers'
						/>
					)}
				</SidebarMenuItemWithSub>
			)}
			{/* Переезд на Страту заморожен, а код уже в мастере: без флага
			    оператор в проде видит пункт меню, за которым пустые экраны.
			    Третья сторона того же выключателя — рядом с ним STRATAPAY_ENABLED
			    на бэке и VITE_STRATAPAY_ENABLED на витрине. */}
			{isManager && SHOW_STRATAPAY_SECTIONS && (
				<SidebarMenuItemWithSub
					to='/apps/stratapay/*'
					icon='two-credit-cart'
					title='Stratapay'
				>
					<SidebarMenuItem
						to='/apps/stratapay/withdrawals'
						icon='dollar'
						title='Заявки на вывод'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/stratapay/automatic'
						icon='abstract-8'
						title='История автовыводов'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{/* Роль ровно та, что требуют ручки (/admin/payment-services под
			    admin_role_depend). Показать пункт шире значило бы отдать
			    оператору тумблеры, за которыми его ждёт ошибка загрузки. */}
			{isAdmin && (
				<SidebarMenuItem
					to='/apps/payment-services'
					icon='switch'
					title='Платёжные сервисы'
					fontIcon='bi-layers'
				/>
			)}
			{isManager && (
				<SidebarMenuItem
					to='/apps/settings'
					icon='shield-tick'
					title='Код верификации'
					fontIcon='bi-layers'
				/>
			)}
			{isManager && (
				<SidebarMenuItemWithSub
					to='/apps/feed/*'
					icon='abstract-39'
					title='Лента'
				>
					<SidebarMenuItem
						to='/apps/feed/posts'
						icon='book'
						title='Посты'
						fontIcon='bi-layers'
					/>
					<SidebarMenuItem
						to='/apps/feed/tags'
						icon='abstract-14'
						title='Теги'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{/* Раздел прячется целиком: группы категорий и топики обслуживают
			    замороженную витрину, а новости публикуются в группу, которую в
			    проде никто не привязывал. Оставлять меню ради одного пункта,
			    который всё равно никуда не ведёт, незачем. */}
			{isManager && SHOW_TELEGRAM_SECTIONS && (
				<SidebarMenuItemWithSub
					to='/apps/telegram/*'
					icon='message-text-2'
					title='Telegram'
				>
					{/* Тоже про магазины: за категориями закрепляют группы, в
					    которых магазины публикуют объявления, а на той же
					    странице висит здоровье бота-манагера — того, через
					    которого продавцы заводят ботов своих магазинов. Без
					    флага раздел оставался единственным окном в замороженную
					    витрину, открытым в проде. */}
					{SHOW_SHOP_SECTIONS && (
						<SidebarMenuItem
							to='/apps/telegram/categories'
							icon='abstract-26'
							title='Группы категорий'
							fontIcon='bi-layers'
						/>
					)}
					{SHOW_SHOP_SECTIONS && (
						<SidebarMenuItem
							to='/apps/telegram/topics'
							icon='shop'
							title='Топики магазинов'
							fontIcon='bi-layers'
						/>
					)}
					<SidebarMenuItem
						to='/apps/telegram/news'
						icon='book'
						title='Новости платформы'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{/* Разделы про магазины: на деве видны, в проде скрыты, пока не
			    доведены. Раньше просто лежали закомментированными — то есть
			    посмотреть на них было нельзя нигде, даже на стенде. */}
			{isManager && SHOW_SHOP_SECTIONS && (
				<SidebarMenuItem
					to='/apps/shops'
					icon='shop'
					title='Магазины'
					fontIcon='bi-layers'
				/>
			)}
			{isManager && SHOW_SHOP_SECTIONS && (
				<SidebarMenuItemWithSub
					to='/apps/subscription/*'
					icon='note'
					title='Подписки'
				>
					{/* exact: адрес тарифов — начало адреса заявок, и без него
					    подсвечивались бы оба пункта сразу. */}
					<SidebarMenuItem
						to='/apps/subscription'
						icon='note'
						title='Тарифы'
						fontIcon='bi-layers'
						exact
					/>
					<SidebarMenuItem
						to='/apps/subscription/free-requests'
						icon='questionnaire-tablet'
						title='Заявки на бесплатную'
						fontIcon='bi-layers'
					/>
				</SidebarMenuItemWithSub>
			)}
			{isManager && SHOW_SHOP_SECTIONS && (
				<SidebarMenuItem
					to='/apps/themes'
					icon='colors-square'
					title='Темы'
					fontIcon='bi-layers'
				/>
			)}
		</>
	);
};

export { SidebarMenuMain };
